import React, { useState, useContext, useEffect } from "react";
import "./AudioCallGridLayout.css"; // Import CSS styles
import UMGridLeftLayout from "./Layout/ADCGridLeftLayout"
import UMGridCentreLayout from "./Layout/ADCgridCentreLayout"
import GridLeftLayout from "../../AccountPage/Layout/UserAccountGridLeft"
import { ThemeContext } from "../../../../context/ThemeContext";
import "../Styles/uac-common-styles.css"

// mode will be either Group, friend or Admirer. Based on mode selection our left navbar design being changed. 

const AudioCallPageGrid = ({recipientId, mode}) => {
  const { theme } = useContext(ThemeContext);

  useEffect(() => {
        import(`./Styles/themes/${theme}/themes.css`).then(() => {
          console.log(`Loaded ${theme} styles for UserProfile`);
        }).catch(() => {
          console.error(`Theme CSS not found for ${theme}`);
        });
      }, [theme]);

  return (
    <div className="uac-page-grid" >
      {/* Left Sidebar */}
      <div className="uac-left-sidebar-container">
        <UMGridLeftLayout recipientId={recipientId} mode={mode}/>
      </div>

      {/* Middle Container */}
      <div className="uac-popover-middle-container">
        <UMGridCentreLayout recipientId={recipientId} />
      </div>        
    </div>
  );
};

export default AudioCallPageGrid;